module.exports = __webpack_public_path__ + "img/logobarra.017bc8c8.png";